import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { ProjectManagerService } from '../services/project-manager.service';
import { DeckHeightService } from '../services/deck-height.service';
import { SnapShotService } from '../services/snap-shot.service';
import { BuildFloorService } from '../services/build-floor.service';
import { ModalStartScreenComponent } from '../shared/modals/modal-start-screen/modal-start-screen.component';
import { MatDialog } from '@angular/material';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';
import { SetMaterialsService } from '../services/set-materials.service';
import { AppSettingsService } from '../services/app-settings.service';
import { SceneryService } from '../services/scenery.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { ProductsService } from '../services/products.service';
import { Model3DService } from '../services/model3-d.service';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { StageService } from '../services/stage.service';
import { TourService } from '../services/tour.service';
import { CookieServiceService } from '../services/cookie-service.service';
import { CameraService } from '../services/camera.service';
import { AuthService } from '../services/auth.service';
import { AnalyticsService } from '../services/analytics.service';
import { ModalGetQuoteInfoComponent } from '../shared/modals/modal-get-quote/modal-get-quote-info/modal-get-quote-info.component';
import { AddonManagerService } from '../services/addon-manager.service';
import { GetQuoteService } from '../shared/modals/modal-get-quote/services/get-quote.service';
import { SceneLoadingService } from '../services/scene-loading.service';
import { DockModeService } from '../services/dock-mode.service';
declare let THREE: any;

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {
  private projectId;
  private currentProject;
  isGetAQuote = false;
  isSidebarCollapsed = false;
  constructor(
    private activateRoute: ActivatedRoute,
    private projectSrvc: ProjectManagerService,
    private snapshotSrvc: SnapShotService,
    private deckHeightService: DeckHeightService,
    private buildFloorService: BuildFloorService,
    private dialog: MatDialog,
    private railingGeneration: RailingGenerationService,
    private setMaterialService: SetMaterialsService,
    private appSettingsService: AppSettingsService,
    private sceneryService: SceneryService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private productSrvc: ProductsService,
    private model3D: Model3DService,
    private loadingSpinnerService: LoadingSpinnerService,
    private stage: StageService,
    public tour: TourService,
    private cookieServiceService: CookieServiceService,
    private cameraService: CameraService,
    private auth: AuthService,
    private toasterService: ToasterService,
    private analyticsService: AnalyticsService,
    private addonManagerService: AddonManagerService,
    private getQuoteService: GetQuoteService,
    private sceneLoadingService: SceneLoadingService,
    private dockModeService: DockModeService,
  ) {}

  private applyDockModeFromUrl() {
    const mode = new URLSearchParams(window.location.search).get('mode');
    if (mode && mode.toLowerCase() === DockModeService.URL_PARAM_VALUE) {
      this.dockModeService.setDockMode(true);
      this.projectSrvc.setProjectType(DockModeService.PROJECT_TYPE);
    }
  }

  showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  openStartScreenDialog(): void {
    let dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'Data'
    });
    if (this.cookieServiceService.getCookie('isTourViewed') !== 'viewed') {
      dialogRef.close();
      dialogRef.afterClosed().subscribe(result => {
        // console.log('Start screen dialog was closed');
        this.tour.showTour();
      });
    } else {
      dialogRef.afterClosed().subscribe(result => {
        // console.log('Start screen dialog was closed');
      });
    }
  }

  openGetAQuoteDialog(projectType): void {
    let dialogRef = this.dialog.open(ModalGetQuoteInfoComponent, {
      width: '835px',
      height: '75vh',
      data: {projectType}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('Start screen dialog was closed');
    });
  }

  buildFloors(tiers: any[]): void {
    for (const tier of tiers) {
      this.buildFloorService.buildFloor({
        points: tier.points,
        height: tier.height,
        mainFloor: tier.mainFloor,
        customId: tier.customId,
        parentCustomId: tier.parentCustomId
      });
    }
  }

  buildAccessories(accessories): void {
    // console.log('buildAccessories accessories', accessories);
    for (const accessory of accessories) {
      this.productSrvc.getAccessories().then(accessories => {
        const activeEntity = accessories.find(a => (a.id === accessory.id || (a.customid && accessory.id === a.customid)));
        
        // Check if activeEntity is found
        if (!activeEntity) {
          console.warn(`Accessory with id ${accessory.id} not found`);
          this.loadingSpinnerService.spinnerLoadingListRemove('buildAccessories' + accessory.id);
          return;
        }
        
        const rotation = new THREE.Euler(
          accessory.rotation.x,
          accessory.rotation.y,
          accessory.rotation.z,
          'XYZ'
        );
        this.loadingSpinnerService.spinnerLoadingListAdd('buildAccessories' + accessory.id);
        this.model3D
          .create(activeEntity, {
            position: accessory.position,
            rotation: rotation,
            wall: null,
            show3DObject: true
          })
          .then(obj => {
            // obj.userData.boundingBox = boundingBox;
            obj.userData.entity = activeEntity;
            obj.name = activeEntity.productType;
            const tiers = this.stage.getCompoundFloor().children;
            const tier = tiers.find(t => t.userData.customId === accessory.parentId);
            if (tier) {
              tier.updateMatrixWorld(true);
              obj.updateMatrixWorld(true);
              this.stage.getScene().updateMatrixWorld(true);
              THREE.SceneUtils.attach(obj, this.stage.getScene(), tier);
            }
            this.loadingSpinnerService.spinnerLoadingListRemove('buildAccessories' + accessory.id);
          });
      });
    }
  }

  signInByAddon(userIdFromUrl, userTokenFromUrl) {
    this.auth.getUserById(userIdFromUrl, userTokenFromUrl).subscribe(
      user => {
        console.log('user', user);

        this.auth.setUser(user);
        this.auth.setToken(userTokenFromUrl);

          // console.log('Sign in: isAuthorization = true');
          if (user.hasOwnProperty('role')) {
            this.auth.setRole(user.role.name);
          } else {
            this.auth.setRole('user');
          }

          this.auth.setIsAuthorization(true);
          // this.firstName = token.user.firstName;

          this.auth.setEmail(user.email);
          this.auth.setUserId(user.id);
          sessionStorage.setItem('token', JSON.stringify({id: userTokenFromUrl, user, userId: user.id}));
          sessionStorage.setItem('isAuthorization', JSON.stringify(true));

          // this.onLoginSuccess.emit();
          this.analyticsService.onUserLoggedIn(this.auth.userId);

      },
      err => {
        this.showToast('error', 'Login failed', 'Wrong email or password');
      }
    );
  }

  async isAuthorisedInAddon() {
    // ?userId=633c17db92a3ce668c36aa77&token=umrljRVx8TeMkCifY6O0HDAERInVWIJMDsSprfudvMC8BLKXnWXWZLkGBUDtGrKH
    const userIdFromUrl = new URLSearchParams(window.location.search).get('userId');
    const userTokenFromUrl = new URLSearchParams(window.location.search).get('token');
    if (userIdFromUrl && userTokenFromUrl) {
      this.signInByAddon(userIdFromUrl, userTokenFromUrl);
    }
  }
// isBackFromAddonByGetAQuote
   choiceStartModalByUrlParams() {
    const addonId = new URLSearchParams(window.location.search).get('addonId');
    if (addonId && addonId !== 'undefined' && addonId !== 'null') {
      this.addonManagerService.getAddonProject(addonId).subscribe(addon => {
        console.log('addon', addon);
        if (addon) {
          this.addonManagerService.setAddonProject(addon);
          setTimeout(() => {
            // this.openGetAQuoteDialog('interior');
            this.getQuoteService.getQuoteForAddon().subscribe();
          }, 1000);
        } else {
          this.newProjectModal();
        }
      },
        error => {
          this.showToast('error', 'getting a quote is failed, project id isn`t correct', 'try other id');
        }
      );
    } else {
      this.newProjectModal();
    }
  }

   newProjectModal() {
    this.activateRoute.paramMap.subscribe(params => {
      this.projectId = params.get('id');
      // console.log('projectId', this.projectId);

      if (this.projectId != null) {
        this.projectSrvc.getProject(this.projectId).subscribe(prj => {
          this.currentProject = prj;
          /*this.snapshotSrvc.setSnapshots(this.currentProject.snapshots);
          this.projectSrvc.setProject(this.currentProject);
          this.deckHeightService.setDeckHeight(this.currentProject.deckHeight || 8);

          // to do
          // refactor
          // what does this file do?
          // naming is bad
          this.buildFloor.removeFloor();
          this.buildFloor.buildFloor({points: this.currentProject.points});
          this.railingGeneration.buildRailing(this.railingGeneration.IsVisible());*/
          this.dockModeService.setDockModeFromProjectType(this.currentProject.projectType);
          this.productSrvc.shareProjPromise.then(res => {
            this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
            this.snapshotSrvc.setSnapshotsProTools(this.currentProject.snapshotsProTools);
            this.projectSrvc.setProject(this.currentProject);
            this.projectSrvc.setIsSavedProject(false);
            this.buildFloorService.setCompundFloorPosY(this.currentProject.deckHeight * 2.54);
            this.deckHeightService.setDeckHeight(this.currentProject.deckHeight || 8);
            this.buildFloors(this.currentProject.tiers);
            this.buildAccessories(this.currentProject.accessories);
            this.appSettingsService.setScenery(this.currentProject.scenery);
            this.sceneryService.change(this.currentProject.scenery);
            this.projectSrvc.setSharedProjID(this.projectId);
            this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
            this.dataForDisplayingMenuItemsService.setCurrentParams(this.currentProject.railing);
            // this.dataForDisplayingMenuItemsService.setDefaultParams();
            this.railingGeneration.buildRailing(true);
            this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
            this.cameraService.switchTo2D();
            
            // Принудительно проверяем состояние загрузки сцены после установки параметров
            setTimeout(() => {
              this.sceneLoadingService.forceCheck();
            }, 100);
          });
        });
        //this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
      } else {
        setTimeout(() => {
          this.openStartScreenDialog();
        }, 1000);
      }
    });
  }

   ngOnInit() {
    this.applyDockModeFromUrl();
    this.isAuthorisedInAddon();
    this.choiceStartModalByUrlParams();
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 320);
  }
}



// WEBPACK FOOTER //
// ./src/app/container/container.component.ts